(function () {
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function formatNumber(value, decimals) {
    return value.toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function animateStat(el) {
    var target = parseFloat(el.dataset.target || '0');
    var decimals = parseInt(el.dataset.decimals || '0', 10);
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var duration = parseInt(el.dataset.duration || '1600', 10);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = prefix + formatNumber(target, decimals) + suffix;
      return;
    }

    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var current = target * easeOutExpo(progress);
      el.textContent = prefix + formatNumber(current, decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function initTrustStats(root) {
    var numbers = root.querySelectorAll('.trust-stats__number');
    if (!numbers.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateStat(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    numbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('.trust-stats').forEach(function (root) {
      if (root.dataset.trustStatsInit) return;
      root.dataset.trustStatsInit = 'true';
      initTrustStats(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTrustStats(event.target);
  });
})();
